var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMaterialShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.995,
    height: 20.995,
    viewBox: "0 0 20.995 20.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-shopping-cart",
    "data-name": "Icon material-shopping-cart",
    d: "M7.8,19.8a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,7.8,19.8ZM1.5,3V5.1H3.6l3.779,7.967L5.961,15.639A2.03,2.03,0,0,0,5.7,16.647a2.106,2.106,0,0,0,2.1,2.1H20.4v-2.1H8.239a.26.26,0,0,1-.262-.262l.031-.126.945-1.711h7.821a2.09,2.09,0,0,0,1.837-1.081l3.758-6.813a1.026,1.026,0,0,0,.126-.5,1.053,1.053,0,0,0-1.05-1.05H5.919L4.933,3ZM18.3,19.8a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,18.3,19.8Z",
    transform: "translate(-1.5 -3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaterialShoppingCart);
export default __webpack_public_path__ + "static/media/Icon-material-shopping-cart.c42044a2a2f82cdda338322bd19b7d92.svg";
export { ForwardRef as ReactComponent };